export const AUTO_SPEED_PLAY_CAROUSEL = 2000;
